/* tslint:disable */
import {
  Product
} from '../index';

declare var Object: any;
export interface PartnerLerProductInterface {
  "id"?: number;
  "name"?: string;
  "active"?: boolean;
  "product_id"?: number;
  product?: Product;
}

export class PartnerLerProduct implements PartnerLerProductInterface {
  "id": number;
  "name": string;
  "active": boolean;
  "product_id": number;
  product: Product;
  constructor(data?: PartnerLerProductInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PartnerLerProduct`.
   */
  public static getModelName() {
    return "PartnerLerProduct";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PartnerLerProduct for dynamic purposes.
  **/
  public static factory(data: PartnerLerProductInterface): PartnerLerProduct{
    return new PartnerLerProduct(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PartnerLerProduct',
      plural: 'PartnerLerProducts',
      path: 'PartnerLerProducts',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "active": {
          name: 'active',
          type: 'boolean'
        },
        "product_id": {
          name: 'product_id',
          type: 'number'
        },
      },
      relations: {
        product: {
          name: 'product',
          type: 'Product',
          model: 'Product',
          relationType: 'belongsTo',
                  keyFrom: 'product_id',
          keyTo: 'id'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/PartnerLerProduct.ts